import {
  PRODUCE_CAROUSEL_IMAGES,
  SEEDS_CAROUSEL_IMAGES,
  TOOLS_CAROUSEL_IMAGES,
  LOCAL_CAROUSEL_IMAGES,
} from "../constants/images";

// Real Greenbless category slugs (see Schemas/supabase_schema.sql +
// Schemas/add_greenbless_categories.sql) that have their own hero carousel.
export function getHeroImages(cat) {
  const slug = String(cat || "").trim().toLowerCase();
  if (slug === "fresh-produce") return PRODUCE_CAROUSEL_IMAGES.slice();
  if (slug === "seeds-plants") return SEEDS_CAROUSEL_IMAGES.slice();
  if (slug === "garden-tools") return TOOLS_CAROUSEL_IMAGES.slice();
  return LOCAL_CAROUSEL_IMAGES.slice();
}
